import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "breakingChangesCheckbox",
    "migrationField",
    "migrationCheckbox",
    "wasmFile",
    "wasmFilename"
  ]

  connect() {
    this.restoreFormUi()
  }

  restoreFormUi() {
    this.resetWasmFileInput()
    this.toggleMigrationField()
  }

  resetWasmFileInput() {
    if (!this.hasWasmFileTarget) return

    this.wasmFileTarget.disabled = false
  }

  discardAttachedWasm() {
    this.element
      .querySelectorAll('input[type="hidden"][name="app_bundle_version[wasm_file]"]')
      .forEach((input) => input.remove())

    if (this.hasWasmFilenameTarget) {
      this.wasmFilenameTarget.remove()
    }

    if (!this.hasWasmFileTarget) return

    this.wasmFileTarget.disabled = false
    this.wasmFileTarget.value = ""
    this.wasmFileTarget.required = true
  }

  toggleMigrationField() {
    const hasBreakingChanges = this.breakingChangesCheckboxTarget.checked
    const hasBaseVersion = this.hasBaseVersionSelected()

    if (hasBreakingChanges) {
      // Hide migration field and uncheck migration checkbox
      this.migrationFieldTarget.style.display = 'none'
      this.migrationCheckboxTarget.checked = false
    } else if (hasBaseVersion) {
      // Show migration field
      this.migrationFieldTarget.style.display = 'block'
    } else {
      // Hide migration field if no base version selected
      this.migrationFieldTarget.style.display = 'none'
      this.migrationCheckboxTarget.checked = false
    }
  }

  hasBaseVersionSelected() {
    const baseVersionSelect = this.element.querySelector('select[name*="base_version_id"]')
    return baseVersionSelect && baseVersionSelect.value !== ''
  }
}
